<template>
    <div class="flex flex-col bg-background3 largeMax:min-h-screen large:h-screen">
        <div class="relative w-full pt-4 z-10 largeMax:pb-5 large:pt-[1.375rem]">
            <div class="container">
                <div class="wrap-quiz">
                    <div class="flex justify-between items-center relative">
                        <div v-if="$root.config.translations?.misc?.back">
                            <button class="button button--secondary-on-light button--small gap-x-1 box-border h-8 text-[0.6875rem] large:h-[2.6875rem]" @click="[handleBack(), transitionReverse = true]">
                                <span>‹</span>
                                <span class="button__label">
                                    {{ $root.config.translations.misc.back }}
                                </span>
                            </button>
                        </div>
                        <a
                            v-if="$root.data.logo"
                            href="/"
                            class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 block w-[7.5rem] large:w-[10rem]"
                        >
                            <img
                                class="w-full"
                                :src="$root.data.logo"
                                width="120"
                                height="17"
                                alt="Aurelia"
                                loading="eager"
                            >
                        </a>
                        <div
                            v-if="$root.config.translations?.misc?.close"
                            class="flex items-center justify-end"
                        >
                            <a
                                :href="$root.data.landingPage"
                                class="button button--secondary-on-light button--small justify-center items-center box-border w-8 h-8 large:w-[2.6875rem] large:h-[2.6875rem]"
                                :aria-label="$root.config.translations.misc.close"
                            >
                                <svg class="shrink-0 w-2 h-auto" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.60778 7.75229C7.81777 7.5423 7.82634 7.19946 7.62063 6.99375L4.77078 4.1439L7.53921 1.37547C7.74491 1.16976 7.74491 0.818354 7.53492 0.608364C7.32493 0.398375 6.97781 0.402661 6.77211 0.608365L4.00367 3.37679L1.14953 0.522655C0.943831 0.316951 0.600992 0.325522 0.391003 0.535511C0.181013 0.7455 0.176728 1.08405 0.382432 1.28976L3.23657 4.1439L0.463856 6.91661C0.258152 7.12232 0.253867 7.46944 0.463856 7.67943C0.673845 7.88942 1.02526 7.88942 1.23096 7.68372L4.00367 4.911L6.85353 7.76086C7.05923 7.96656 7.39779 7.96227 7.60778 7.75229Z" fill="currentColor"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition
            :name="transitionReverse ? 'slide-fade-reverse' : 'slide-fade'"
            mode="out-in"
        >
            <div v-if="$route.name !== 'EmailOptIn'" class="mt-3 large:mt-[3.625rem]">
                <div class="container">
                    <div class="wrap-quiz">
                        <div class="flex flex-col justify-center items-center gap-y-4 large:gap-y-[1.875rem]">
                            <span class="heading-xxs font-bold uppercase">{{ $root.config.translations.misc.question }} {{ (paramsLength - questionsLength) + questionsLength }} {{ $root.config.translations.misc.of }} {{ questionsLength }}</span>
                            <div class="relative w-[21.125rem] max-w-full h-1 bg-[#D9D9D9] overflow-hidden large:w-[54.375rem]">
                                <div :style="`width: ${progressBar}%`" class="h-1 bg-[#272727] transition-all duration-700" />
                                
                                <!-- Adds progress indicators -->
                                <div v-for="n in questionsLength" class="absolute top-0 w-[0.3125rem] h-full bg-background3 -translate-x-1/2" :style="`left: ${(n / questionsLength) * 100}%;`" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <div class="container flex justify-center relative z-10 pt-10 overflow-auto scroll-smooth large:pt-16 js-route-content-container">
            <div class="wrap-quiz w-full largeMax:pb-[4.375rem] large:flex large:flex-col">
                <router-view v-slot="{Component, route}">
                    <transition
                        :name="transitionReverse ? 'slide-fade-reverse' : 'slide-fade'"
                        mode="out-in"
                        @after-enter="transitionReverse = false"
                    >
                        <component ref="route" :is="Component" :key="route.path" class="relative z-10 large:my-auto large:pb-[7.6875rem]" />
                    </transition>
                </router-view>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                questionsLength: 7,
                transitionReverse: false
            }
        },
        computed: {
            paramsLength () {
                return Object.keys(this.$route.params).length + 1;
            },
            progressBar () {
                return (100 / this.questionsLength) * this.paramsLength;
            }
        },
        methods: {
            handleBack () {
                if (this.$root.config.navigation.secondary) {
                    this.$refs.route.secondaryActive = false;
                    this.$refs.route.primaryActive = true;
                    this.$refs.route.value = [];
                    this.$root.config.navigation.secondary = false;
                } else if (this.$route.meta.back) {
                    this.$router.push({
                        name: this.$route.meta.back
                    })
                } else {
                    window.location = this.$root.data.landingPage;
                }
            }
        }
    };
</script>

<style scoped>
    .slide-fade-enter-active,
    .slide-fade-leave-active,
    .slide-fade-reverse-enter-active,
    .slide-fade-reverse-leave-active {
        transition: all 0.3s ease-out;
    }

    .slide-fade-reverse-leave-to,
    .slide-fade-enter-from {
        @apply translate-y-[1.25rem];
        @apply opacity-0;
    }

    .slide-fade-reverse-enter-from,
    .slide-fade-leave-to {
        @apply -translate-y-[1.25rem];
        @apply opacity-0;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.1s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
</style>

<style>
    @keyframes klv-spin {
        to {
        transform: rotate(360deg);
        }
    }

    .btn--loading[disabled] {
        @apply relative;
        @apply text-transparent;
    }

    .btn--loading[disabled]::after {
        content: "";
        @apply absolute top-1/2 left-1/2 w-4 h-4 border-2 border-black rounded-full;
        border-top-color: transparent;
        @apply mt-[-0.5rem] ml-[-0.5rem];
        animation: klv-spin 0.8s linear infinite;
    }
</style>